import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-href", "onClick"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode("#")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Live = _resolveComponent("Live")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.url,
    custom: ""
  }, {
    default: _withCtx((scope) => [
      _createElementVNode("span", _mergeProps({
        class: ["tag", { 'tag--live': _ctx.isLive, [`tag--${_ctx.isContrast() ? 'light' : 'dark'}`]: _ctx.showColor && !_ctx.isLive }],
        style: _ctx.showColor && !_ctx.isLive ? { backgroundColor: _ctx.tag.tagColor } : null
      }, _ctx.$attrs, {
        "data-href": !_ctx.isLive ? scope?.href : null,
        onClick: ($event: any) => (!_ctx.isLive ? scope?.navigate($event) : null)
      }), [
        (_ctx.showHashtag && !_ctx.isLive)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLive)
          ? (_openBlock(), _createBlock(_component_Live, { key: 1 }))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(!_ctx.isLive ? _ctx.tag.tag : 'Élő'), 1)
      ], 16, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}